import React from "react";
import { Box, Grid, Typography, Link } from "@mui/material";
import "../styles/Footer.css";

const LINKEDIN = "https://www.linkedin.com/company/infrablaze";

/**
 * Slim legal strip beneath MarketingInfoBar: copyright + legal links + a
 * social link. Deliberately minimal.
 */
const Footer = () => {
  const year = new Date().getFullYear();
  const legalLinks = (
    <>
      <Link href="/terms-of-use" underline="hover">
        Terms of Service
      </Link>{" "}
      |{" "}
      <Link href="/privacy-policy" underline="hover">
        Privacy Policy
      </Link>{" "}
      |{" "}
      <Link href="/faqs" underline="hover">
        FAQs
      </Link>{" "}
      |{" "}
      <Link href="/contact" underline="hover">
        Contact
      </Link>
    </>
  );

  return (
    <Box
      component="footer"
      className="ib-footer"
      sx={{ pb: "max(8px, env(safe-area-inset-bottom))" }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{
          flexDirection: { xs: "column", md: "row" },
          rowGap: 0.75,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Grid item xs={12} md="auto">
          <Typography variant="body2" color="text.secondary">
            <strong>© {year} InfraBlaze</strong>. All Rights Reserved. &nbsp;|&nbsp; {legalLinks}
          </Typography>
        </Grid>

        <Grid item xs={12} md="auto" sx={{ textAlign: { xs: "center", md: "right" } }}>
          <Typography variant="body2" color="text.secondary">
            <Link href={LINKEDIN} underline="hover" target="_blank" rel="noopener">
              LinkedIn
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
